<template>
  <el-form-item :label="i18nt('designer.setting.okButtonLabel')">
    <el-input type="text" v-model="optionModel.okButtonLabel"></el-input>
  </el-form-item>
</template>

<script>
  import i18n from "../../../../../utils/i18n"
  import propertyMixin from "../propertyMixin"

  export default {
    name: "okButtonLabel-editor",
    mixins: [i18n, propertyMixin],
    props: {
      designer: Object,
      selectedWidget: Object,
      optionModel: Object,
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// okButtonLabel-editor.vue?5a4461b0